module.exports = __webpack_public_path__ + "img/1.e8fff685.png";